// Notification sound - generated from a simple notification tone
const NOTIFICATION_SOUND_URL = 'https://actions.google.com/sounds/v1/alarms/beep_short.ogg';

class NotificationService {
  constructor() {
    this.permission = typeof Notification !== 'undefined' ? Notification.permission : 'denied';
    this.audio = null;
    this.serviceWorkerRegistration = null;
    this.soundEnabled = true;
    this.initAudio();
  }

  initAudio() {
    try {
      this.audio = new Audio(NOTIFICATION_SOUND_URL);
      this.audio.volume = 0.5;
      // Preload audio
      this.audio.load();
    } catch (e) {
      console.log('Audio init failed:', e);
    }
  }

  async init() {
    // Register service worker
    if ('serviceWorker' in navigator) {
      try {
        this.serviceWorkerRegistration = await navigator.serviceWorker.register('/sw.js');
        console.log('Service Worker registered');
      } catch (error) {
        console.error('Service Worker registration failed:', error);
      }
    }
  }

  async requestPermission() {
    if (!('Notification' in window)) {
      console.log('This browser does not support notifications');
      return false;
    }

    if (Notification.permission === 'granted') {
      this.permission = 'granted';
      return true;
    }

    if (Notification.permission !== 'denied') {
      const permission = await Notification.requestPermission();
      this.permission = permission;
      return permission === 'granted';
    }

    return false;
  }

  setSoundEnabled(enabled) {
    this.soundEnabled = enabled;
    localStorage.setItem('notification_sound_enabled', enabled ? 'true' : 'false');
  }

  isSoundEnabled() {
    const stored = localStorage.getItem('notification_sound_enabled');
    if (stored !== null) {
      this.soundEnabled = stored === 'true';
    }
    return this.soundEnabled;
  }

  async playSound() {
    if (!this.isSoundEnabled()) return;
    
    try {
      // Create fresh audio instance for each play
      const audio = new Audio(NOTIFICATION_SOUND_URL);
      audio.volume = 0.6;
      await audio.play();
    } catch (e) {
      console.log('Audio play failed:', e);
      // Try fallback with original audio
      if (this.audio) {
        try {
          this.audio.currentTime = 0;
          await this.audio.play();
        } catch (e2) {
          console.log('Fallback audio play failed:', e2);
        }
      }
    }
  }

  async showNotification(title, body, url = '/', inquiryId = null) {
    // Play sound
    this.playSound();

    // Check permission
    if (this.permission !== 'granted') {
      const granted = await this.requestPermission();
      if (!granted) {
        console.log('Notification permission not granted');
        return;
      }
    }

    // Use service worker notification if available (works in background)
    if (this.serviceWorkerRegistration) {
      try {
        await this.serviceWorkerRegistration.showNotification(title, {
          body,
          icon: '/logo192.png',
          badge: '/logo192.png',
          vibrate: [100, 50, 100],
          tag: inquiryId || 'notification',
          renotify: true,
          data: { url, inquiryId },
          actions: [
            { action: 'open', title: 'Öffnen' },
            { action: 'close', title: 'Schließen' }
          ]
        });
        return;
      } catch (e) {
        console.log('SW notification failed, falling back to regular notification');
      }
    }

    // Fallback to regular notification
    try {
      const notification = new Notification(title, {
        body,
        icon: '/logo192.png',
        tag: inquiryId || 'notification',
        renotify: true
      });

      notification.onclick = () => {
        window.focus();
        if (url) {
          window.location.href = url;
        }
        notification.close();
      };
    } catch (e) {
      console.log('Notification failed:', e);
    }
  }
}

// Create singleton instance
const notificationService = new NotificationService();

export default notificationService;
